/** What a CSS module exports: authored class name to hashed class name. */
export type ClassMap = Readonly<Record<string, string | undefined>>;

const capitalize = (word: string): string =>
  word.charAt(0).toUpperCase() + word.slice(1);

/**
 * The hashed class behind a block's BEM size modifier, keyed by the exact
 * `block__modX` name a v2 stylesheet declares. A size whose values are the
 * block's own defaults has no modifier and resolves to undefined.
 */
export const sizeClass = (
  styles: ClassMap,
  block: string,
  size: string,
): string | undefined => styles[`${block}__mod${capitalize(size)}`];
